let view = null;

class View404 {
	constructor(container) {
		this.container = container;
	}

	init() {
		//
	}
}

export default {
	namespace: '404',
	beforeEnter: ({ current, next, trigger }) => {
		view = new View404(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view = null;
	},
};
